import { render, staticRenderFns } from "./PettyPrintComponent.vue?vue&type=template&id=3f86920f"
import script from "./PettyPrintComponent.vue?vue&type=script&lang=js"
export * from "./PettyPrintComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports